<div class="logo" title="Agree"></div>

<div class="app-content" #mainFrame id="agree-main">
    <router-outlet></router-outlet>
</div>